module.exports = __webpack_public_path__ + "img/ys.0a14afc8.png";